const removeStrings = value => value.replace(/[^0-9]/g, "");

const convertIntoNumber = value => parseInt(removeStrings(value));

export default {
    convertIntoNumber
};
